import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Tab, Nav, Badge, Dropdown } from "react-bootstrap";
import Completed from '../../../modal/Lead_Management/Manage_Appointment/Appointment_Completed';
import Cancelled from '../../../modal/Lead_Management/Manage_Appointment/Appointment_Cancelled';
import View from '../../../modal/Lead_Management/Manage_Appointment/View';
import axios from 'axios';
const Manage_Appointment = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [responses, setresp] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    
    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);
    
    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm  // add search string
        };
        axios.get(`${baseURL}/appointment`, { params: params })
            .then(response => {
                setData(response.data.data);
                setresp(response.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };
    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const handleViewModalToggle = (selectedRow) => {
        setSelectedRow(selectedRow);
        setModalType("View");
        setOpen(true);
    };

    const handleCompleteModalToggle = (selectedRow) => {
        setSelectedRow(selectedRow);
        setModalType("Complete");
        setOpen(true);
    };

    const handleCancellModalToggle = (selectedRow) => {
        setSelectedRow(selectedRow);
        setModalType("Cancell");
        setOpen(true);
    };

    useEffect(() => {
        const tables = document.querySelectorAll('.trip_sheet_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);

    const appointment_category = [
        { value: 1, label: "Walk-in" },
        { value: 2, label: "Online" },
        { value: 3, label: "Ofline" },
        { value: 4, label: "Video" },
        { value: 5, label: "Payment" }
    ];

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            // Determine AM or PM
            const ampm = hour >= 12 ? 'PM' : 'AM';

            // Convert hour from 24-hour to 12-hour format
            hour = hour % 12;
            if (hour === 0) hour = 12; // the hour '0' should be '12'

            // Return formatted string without seconds (optional)
            return `${hour}:${minute} ${ampm}`;
        } else {
            return '';
        }
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Appointment</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Lead Management</li>
                    </ol>
                </div>

                {open && modalType === "Complete" && (
                    <Completed show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={fetchData} />
                )}

                {open && modalType === "Cancell" && (
                    <Cancelled show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={fetchData} />
                )}

                {open && modalType === "View" && (
                    <View show={open} onClose={() => setOpen(false)} data={selectedRow}  />
                )}
            </div>

            <Row className='mb-4'>
                
                <Col xl={12} className="mb-4">
                    <div className="row g-3">
                        <div className="totalData col-lg-6 border rounded py-3">
                            <h4 className="text-center mb-3">Total</h4>
                            <div className="row gx-3 gy-3 px-2"> {/* <-- spacing between inner cards */}
                                <div className="col-lg-3 border rounded p-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Appointment</span></Tooltip>} >
                                        <div className="text-center d-block" style={{ minWidth: '100px' }}  tabIndex={0}  role="button">
                                            <div className="fw-semibold fs-5 text-black text-center">Total</div>
                                            <div className="d-block mt-2">
                                            <div className="badge bg-primary rounded fw-bold fs-6">{responses.total_appointment}</div>
                                            </div>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                                <div className="col-lg-3 border rounded p-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Completed Appointment</span></Tooltip>} >
                                        <div className="text-center d-block" style={{ minWidth: '100px' }}  tabIndex={0}  role="button">
                                            <div className="fw-semibold fs-5 text-black text-center">Completed</div>
                                            <div className="d-block mt-2">
                                            <div className="badge bg-primary rounded fw-bold fs-6">{responses.completed_appointment}</div>
                                            </div>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                                <div className="col-lg-3 border rounded p-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Cancelled Appointment</span></Tooltip>} >
                                        <div className="text-center d-block" style={{ minWidth: '100px' }}  tabIndex={0}  role="button">
                                            <div className="fw-semibold fs-5 text-black text-center">Cancelled</div>
                                            <div className="d-block mt-2">
                                                <div className="badge bg-primary rounded fw-bold fs-6">{responses.cancelled_appointment}</div>
                                            </div>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                                <div className="col-lg-3 border rounded p-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Pending Appointment</span></Tooltip>} >
                                    <div className="text-center d-block" style={{ minWidth: '100px' }}  tabIndex={0}  role="button">
                                        <div className="fw-semibold fs-5 text-black text-center">Pending</div>
                                        <div className="d-block mt-2">
                                            <div className="badge bg-primary rounded fw-bold fs-6">{responses.pending_appointment}</div>
                                        </div>
                                    </div>
                                    </OverlayTrigger>
                                </div>
                            </div>

                            <div className="d-flex gap-3 justify-content-center mt-4">
                                <div className="total-success text-center border rounded p-3">
                                    <h5>Success rate</h5>
                                    <div className="badge bg-success text-black rounded fw-bold fs-6">{responses.success_rate}%</div>
                                </div>
                                <div className="total-failure text-center border rounded p-3">
                                    <h5>Failure rate</h5>
                                    <div className="badge bg-danger rounded fw-bold fs-6">{responses.fail_rate}%</div>
                                </div>
                            </div>
                        </div>

                        <div className="monthData col-lg-6 border rounded py-3">
                            <h4 className="text-center mb-3"> This Month (<span className="text-info"> {responses.this_month} </span>)</h4>
                            <div className="row gx-3 gy-3 px-2">
                                <div className="col-lg-3 border rounded p-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Appointment</span></Tooltip>} >
                                        <div className="text-center d-block" style={{ minWidth: '100px' }}  tabIndex={0}  role="button">
                                            <div className="fw-semibold fs-5 text-black text-center">Total</div>
                                            <div className="d-block mt-2">
                                            <div className="badge bg-primary rounded fw-bold fs-6">{responses.this_total_appointment}</div>
                                            </div>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                                <div className="col-lg-3 border rounded p-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Completed Appointment</span></Tooltip>} >
                                        <div className="text-center d-block" style={{ minWidth: '100px' }}  tabIndex={0}  role="button">
                                            <div className="fw-semibold fs-5 text-black text-center">Completed</div>
                                            <div className="d-block mt-2">
                                            <div className="badge bg-primary rounded fw-bold fs-6">{responses.this_completed_appointment}</div>
                                            </div>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                                <div className="col-lg-3 border rounded p-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Cancelled Appointment</span></Tooltip>} >
                                        <div className="text-center d-block" style={{ minWidth: '100px' }}  tabIndex={0}  role="button">
                                            <div className="fw-semibold fs-5 text-black text-center">Cancelled</div>
                                            <div className="d-block mt-2">
                                                <div className="badge bg-primary rounded fw-bold fs-6">{responses.this_cancelled_appointment}</div>
                                            </div>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                                <div className="col-lg-3 border rounded p-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Pending Appointment</span></Tooltip>} >
                                    <div className="text-center d-block" style={{ minWidth: '100px' }}  tabIndex={0}  role="button">
                                        <div className="fw-semibold fs-5 text-black text-center">Pending</div>
                                        <div className="d-block mt-2">
                                            <div className="badge bg-primary rounded fw-bold fs-6">{responses.this_pending_appointment}</div>
                                        </div>
                                    </div>
                                    </OverlayTrigger>
                                </div>
                            </div>

                            <div className="d-flex gap-3 justify-content-center mt-4">
                                <div className="total-success text-center border rounded p-3">
                                    <h5>Success rate</h5>
                                    <div className="badge bg-success text-black rounded fw-bold fs-6">{responses.this_success_rate}%</div>
                                </div>
                                <div className="total-failure text-center border rounded p-3">
                                    <h5>Failure rate</h5>
                                    <div className="badge bg-danger rounded fw-bold fs-6">{responses.this_fail_rate}%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>

                <Col xl={12} className='mb-3'>
                    <div className="custom-tab-1">
                        <Row>
                            <Col xl={12}>
                                <div className="table-container">

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        {/* Left: Show entries dropdown */}
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                className="form-select d-inline w-auto"
                                                style={{  fontSize: '0.85rem', height: '30px' }}
                                                value={perPage}
                                                onChange={(e) => {
                                                    setPerPage(Number(e.target.value));
                                                    setPage(1); // Reset to first page
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>

                                        {/* Right: Search input */}
                                        <div>
                                            <input
                                                type="text"
                                                style={{  fontSize: '0.85rem', height: '40px' }}
                                                placeholder="Search..."
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(1); // Reset page on new search
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <table style={{ borderBottom: '2px solid #ddd' }} className=" table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className='min-w-100px'>Lead</th>
                                                <th className='min-w-125px text-start'>Category / Date</th>
                                                <th className='min-w-100px text-start'>Assigned Staff</th>
                                                <th className='min-w-100px text-start'>Appointment Status</th>
                                                <th className='min-w-125px text-start'>Lead Status</th>
                                                <th className='min-w-100px text-end'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            {datas.length === 0 && hasFetched ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center text-muted py-2">
                                                        No data available
                                                    </td>
                                                </tr>
                                            ) : (
                                                <>
                                                    {datas.map((data, index) => (
                                                        <tr key={data.sno}>
                                                            <td>
                                                                <div className="mb-0 align-items-center">
                                                                    <label className="fs-7 me-2 font-w400 text-black" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Lead Name">{data.lead_name}</label>
                                                                    <div className="d-block">
                                                                        <div className="d-block text-dark font-w600 fs-8" title="Mobile No">{data.lead_mobile}</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="text-black fs-7">{appointment_category.find(catego => catego.value == data.appointment_category).label}</div>
                                                                <div className="d-block text-black fs-7">{formatDate(data.appointment_date)} {convert24to12(data.appointment_time)}</div>
                                                            </td>
                                                            <td>
                                                                <label className="fs-7 me-2 text-black">{data.staff_name}</label>
                                                            </td>
                                                            <td>
                                                                {data.appointment_status === 0 ? (
                                                                    <Dropdown drop="">
                                                                        <Dropdown.Toggle as="a" className={`i-false cursor-pointer py-2`}>
                                                                            <Badge bg="none" className='py-1 px-2 fs-8 bg-info' >Appointment Scheduled</Badge>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu >
                                                                            <Dropdown.Item onClick={() => handleCompleteModalToggle(data)} className='text-black' >Appointment Completed</Dropdown.Item>
                                                                            <Dropdown.Item onClick={() => handleCancellModalToggle(data)} className='text-black' >Appointment Cancelled</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                ) : (
                                                                    <>
                                                                        {data.appointment_status === 1 ? (
                                                                            <div className="badge bg-success text-black rounded fw-bold fs-8">Appointment Completed</div>
                                                                        ) : (
                                                                            <div className="badge bg-danger text-white rounded fw-bold fs-8">Appointment Cancelled</div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <Badge bg="none" className='py-1 px-2 fs-8' style={{ background: data.lead_status_bg, color: data.lead_status_txt }}>{data.lead_status_name}</Badge>  
                                                            </td>
                                                            <td>
                                                                <div className="text-end">
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleViewModalToggle(data)}>
                                                                            <span><i className="fa-solid fa-eye fs-5 mt-1"></i></span>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                </div>
                                                                
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            )}
                                        </tbody>
                                    </table>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        {/* Bottom left: Showing x to y of z entries */}
                                        <div>
                                            {datas.length > 0 ? (
                                                <span className="text-muted">
                                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                </span>
                                            ):(
                                                <span className="text-muted">
                                                    Showing 0 to 0 of 0 entries
                                                </span>
                                            )}
                                        </div>

                                        {/* Bottom right: Pagination */}
                                        <nav>
                                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                </li>
                                                {[...Array(totalPages)].map((_, i) => (
                                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                </li>
                                                ))}
                                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                </li>
                                            </ul>
                                        </nav>

                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </>
    )


}
export default Manage_Appointment;